define([
    "skylark-utils/dnd"
], function(dnd) {
    return dnd;
});
